<template>
    <div class="doc-viewer" v-if="current">
        <component :is="current.component" />
        <div class="doc-viewer__history">
            <DocHistory :doc-key="docKey" :value="current.value" />
        </div>
    </div>
</template>
<script>
    import DocHistory from '@/pages/help/DocHistory.vue'
    import { findVersion, getDoc, getLatestVersion } from '@/pages/help/docVersions'

    export default {
        name: 'DocViewer',
        components: { DocHistory },
        props: {
            docKey: { type: String, required: true },
            version: { type: String, default: '' },
        },
        computed: {
            current() {
                return findVersion(this.docKey, this.version)
            },
        },
        created() {
            this.normalizeRoute()
        },
        watch: {
            version() {
                this.normalizeRoute()
            },
        },
        methods: {
            normalizeRoute() {
                const doc = getDoc(this.docKey)
                if (!doc) {
                    this.replaceTo('/cn')
                    return
                }
                // 존재하지 않는 시행일로 접근한 경우 현재 약관 페이지로 보낸다.
                if (!this.current) {
                    this.replaceTo(doc.basePath)
                    return
                }
                // 현재 시행 중인 약관은 기본 경로 하나만 쓴다. (/cn/tos 와 /cn/tos/20260909 중복 방지)
                const latest = getLatestVersion(this.docKey)
                if (this.version && latest && this.version === latest.value) {
                    this.replaceTo(doc.basePath)
                }
            },
            replaceTo(path) {
                if (this.$route.path === path) return
                const result = this.$router.replace(path)
                if (result && result.catch) result.catch(() => {})
            },
        },
    }
</script>
<style scoped>
    .doc-viewer__history {
        padding: 0 30px 40px;
    }

    @media (max-width: 720px) {
        .doc-viewer__history {
            padding: 0 20px 30px;
        }
    }
</style>
